module.exports = __webpack_public_path__ + "static/media/chatbot.6e06b290.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/chatbot.png
// module id = 83
// module chunks = 0